import Paper, { type PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Paper)<PaperProps>(({ theme }) => ({
  borderRadius: theme.spacing(3),
  boxSizing: 'border-box',
  containerType: 'inline-size',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'left',

  '&[data-featured="true"]': {
    borderRadius: theme.spacing(4),
    padding: theme.spacing(1),
  },

  '&[data-size="xlarge"]': {
    alignItems: 'center',
    flexDirection: 'row',
  },

  '&[data-size="small"]': {
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
    flexDirection: 'row',
    padding: theme.spacing(1),

    '&:not(.kmx-car-tile--skeleton):hover': {
      backgroundColor: theme.palette.secondary.faint,
    },
  },
}));
